// use these selectors only on platformBatchDetails page
export const getBatchByUID =
  (batchGroupUID) =>
  ({ batchGroups }) => {
    const batchGroup = batchGroups.batchDetails[batchGroupUID];
    return batchGroup;
  };

export const getEnrolledBatches = ({ paginator }) => {
  return paginator?.enrolledBatches ?? {};
};

export const getBatchByUIDFromData = ({ batchGroups }, batchGroupUID) =>
  batchGroups?.data?.[batchGroupUID] ?? {};

export const getBatchGroupFreeClasses = ({ paginator }) => {
  return paginator?.batchGroupFreeClasses ?? {};
};
